<section class="kpi-row">
  <div class="kpi-summary">
    <h2 class="kpi-row-title">
      <strong>{{ totalDeployments }}</strong> Deployments
    </h2>
    <ul class="kpi-status-list">
      <li class="online">
        <strong>{{ onlineDeployments }}</strong> online
      </li>
      <li class="offline">
        <strong>{{ offlineDeployments }}</strong> offline
      </li>
    </ul>
  </div>

  <div class="kpi-group">
    <h2 class="kpi-group-title">Licenses</h2>
    <ul class="kpi-license-list">
      @for (licenseStat of licenseStats; track licenseStat.label) {
        <li class="kpi-chip {{ licenseStat.color }}">
          <span class="kpi-chip-label">
            <strong>{{ licenseStat.count }}</strong> {{ licenseStat.label }}
          </span>
          @if (licenseStat.expiring) {
            <span class="kpi-license-expiring">
              {{ licenseStat.expiring }} expiring in 30 days
            </span>
          }
        </li>
      }
    </ul>
  </div>
</section>

<section class="kpi-row">
  <div class="kpi-summary">
    <h2 class="kpi-row-title">
      <strong>{{ totalMachines }}</strong> Machines
    </h2>
    <ul class="kpi-status-list">
      <li class="online">
        <strong>{{ onlineMachines }}</strong> online
      </li>
      <li class="offline">
        <strong>{{ offlineMachines }}</strong> offline
      </li>
    </ul>
  </div>

  <div class="kpi-group">
    <h2 class="kpi-group-title">On Latest Build</h2>
    <div class="kpi-up-to-date">
      <strong>{{
        upToDatePercentage === undefined ? "--" : upToDatePercentage + "%"
      }}</strong>
      <span
        class="kpi-progress"
        [style.--kpi-progress]="(upToDatePercentage ?? 0) + '%'"
      ></span>
      <span class="kpi-caption"
        >{{ upToDateMachines }} of {{ versionedMachines }} machines</span
      >
    </div>
  </div>
</section>
